module.exports = __webpack_public_path__ + "media/images/online_streaming/satelite-502e16487723794ceb54f94ee53ddfcf.webp";